import {
    Component,
    OnInit,
} from '@angular/core';

import { AuthService } from '../../user/auth.service';
import { ResponsiveService } from '../../shared/services/responsive.service';
import { RouteContextService } from '../../shared/services/route-context.service';
import { NGXLogger as LoggerService } from "ngx-logger";
import { UserService } from '../../user/user.service';
import { CurrentPollService } from '../core/current-poll.service';
import { PollResultsService } from '../core/poll-results.service';
import { AppShellService } from '../../app-shell/nav/app-shell.service';
import { CommonModule } from '@angular/common';
import { NavBarComponent } from '../../app-shell/nav/nav-bar/nav-bar.component';
import { ContextActionBarComponent } from '../shared/context-action-bar/context-action-bar.component';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { ProgressBarComponent } from '../../shared/progress-bar/progress-bar.component';
import { ConnectionService } from '../../shared/services/connection.service';
import { UIMesageService } from '../../shared/services/ui-message.service';
import { TranslationGeneralService } from '../../shared/translation/translation.general.service';
import { FeedbackButtonComponent } from '../../shared/feedback-button/feedback-button.component';
import { StickyBarComponent } from '../../shared/sticky-bar/sticky-bar.component';
import { CookieConsentComponent } from '../../app-shell/shared/cookie-consent/cookie-consent.component';
import { RecaptchaNoticeComponent } from '../../app-shell/shared/recaptcha-notice/recaptcha-notice.component';
import { BannerComponent } from '../../shared/banner/banner.component';
import { BannerService } from '../../shared/banner/banner.service';
import { AnonymousBanner } from '../../shared/banner/anonymous-banner.class';
import { ConnectionStalledBanner } from '../../shared/banner/connection-stalled-banner.class';
import { ConnectionStatusService } from '../../shared/services/connection-status.service';
import { ConnectionStalledReporter } from '../../shared/services/connection-stalled-reporter';
import { environment } from '../../../environments/environment';
import { AppCheckTelemetryService } from '../core/app-check-telemetry.service';
import { NavigationService } from '../core/navigation.service';
import { isSafeRtdbKey } from 'whocan-lib';
import { TemplateService } from '../core/poll-templates/template.service';
import { TranslateMigratedPipe } from '../../shared/translation/trans-migrated.pipe';
import { VoteBarComponent } from "./vote-bar/vote-bar.component";
import { VoteBarInviteComponent } from "./vote-bar-invite/vote-bar-invite.component";
import { EmbedModeService } from '../../shared/services/embed-mode.service';
import { SamplePollCopyService } from '../features/sample-poll/sample-poll-copy.service';
import { EssSoftwareUpdateService, NgxEssentiaModule } from 'ngx-essentia';




@Component({
    selector: 'whoo-app',
    standalone: true,
    imports: [
        CommonModule,
        RouterModule,
        MatIconModule,
        NavBarComponent,
        ProgressBarComponent,
        ContextActionBarComponent,
        FeedbackButtonComponent,
        StickyBarComponent,
        CookieConsentComponent,
        RecaptchaNoticeComponent,
        BannerComponent,
        TranslateMigratedPipe,
        VoteBarComponent,
        VoteBarInviteComponent,
        NgxEssentiaModule,
    ],
    templateUrl: './whoo-app.component.html',
    styleUrls: ['./../../app.component.scss'],
})
export class WhooAppComponent implements OnInit {
    public online: boolean = false;
    private _translationLoaded = false;
    /** hint with reload button when the database connection does not come up (set once the texts are loaded) */
    public connectionStalledBanner: ConnectionStalledBanner | null = null;
    /** ConnectionStalled telemetry - created in the constructor, independent of the banner and of the translations */
    private readonly connectionStalledReporter: ConnectionStalledReporter;
    constructor(
        public authService: AuthService,
        public responsiveService: ResponsiveService,
        public routeContextService: RouteContextService,
        private logger: LoggerService,
        public userService: UserService,
        public currentPollService: CurrentPollService,
        public pollResultsService: PollResultsService,
        public appShellService: AppShellService,
        private trans: TranslationGeneralService,
        private connection: ConnectionService,
        public uiMessage: UIMesageService,
        private activatedRoute: ActivatedRoute,
        private bannerService: BannerService,
        private navigationService: NavigationService,
        public templateService: TemplateService,
        public embedMode: EmbedModeService,
        public samplePollCopyService: SamplePollCopyService,
        // injected here so the stall timer of the connection status starts with the app, not with the first poll
        private connectionStatus: ConnectionStatusService,
        private softwareUpdate: EssSoftwareUpdateService,
        private appCheckTelemetry: AppCheckTelemetryService,
    ) {
        this.connectionStalledReporter = new ConnectionStalledReporter(this.logger, this.connectionStatus, this.routeContextService, this.appCheckTelemetry, !environment.production);
    }
    async ngOnInit() {
        const ownerId = this.activatedRoute.snapshot.params['ownerId'];
        const pollId = this.activatedRoute.snapshot.params['pollId'];
        let voteUserId = this.activatedRoute.snapshot.params['voteUserId'];
        if (!voteUserId) { voteUserId = this.authService.uid }
        // so we can determine early enough if the user is a polOwner and dispaly the contextbar accordingly;
        // malformed ids (manifest.webmanifest, copied line break) are skipped - the poll page reports them as not found
        if (ownerId && pollId && isSafeRtdbKey(ownerId) && isSafeRtdbKey(pollId) && (!voteUserId || isSafeRtdbKey(voteUserId))) {
            await this.currentPollService.setCurrentPoll(ownerId, pollId, voteUserId)
        }
        this.observeConnection()
        await this.trans.loadTransLationFiles()
        if (!this.embedMode.isEmbedded) {
            // Im Embed-Mode keine globalen App-Chrome-Banner registrieren — die App
            // laeuft im iframe ohne sichtbaren ess-banner-Slot.
            this.bannerService.registerBanner(new AnonymousBanner(this.logger, this.authService, this.trans, this.navigationService))
        }
        // auch im Embed-Mode (dort ist der Spinner sonst das einzige, was der Nutzer sieht) - eigener kompakter Slot im Template
        this.connectionStalledBanner = new ConnectionStalledBanner(this.logger, this.connectionStatus, this.routeContextService, this.trans, this.softwareUpdate)
        this.bannerService.registerBanner(this.connectionStalledBanner)
        this.loadAppTranslations()
    }

    private async loadAppTranslations() {
        this.logger.log('loadAppTranslations: ')
        await this.templateService.loadTransLationFiles()
        this._translationLoaded = true;
        this.logger.log('loadAppTranslations: loaded')
    }

    get translationLoaded(): boolean {
        return this._translationLoaded
    }

    private observeConnection(): void {
        this.connection.start();
        this.connection.behaviorSubjectObservable$.subscribe((online) => {
            this.online = online;
            if (!this.online) {
                this.uiMessage.warning(this.trans.translate('offlineMessage'));
            } else {
                this.uiMessage.dismiss();
            }
        });
    }
}
